<template>
  <div class="page page-single">
    <HeaderSlide />
    <div class="page-container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">最新消息</el-breadcrumb-item>
        <el-breadcrumb-item>{{news['news_title']}}</el-breadcrumb-item>
      </el-breadcrumb>
      <article>
        <div class="page-title">
          {{news['news_title']}} <a accesskey="C" href="#content" title="content" class="accesskey-content" >:::</a>
        </div>
        <section class="des">
          {{news['news_description']}}
        </section>
        <section>
          <div class="section-title"><i class="fas fa-image"></i>相關照片</div>
          <div class="attach-images">
            <hooper 
              :settings="hooperAttachImageSettings" 
              v-if="news['attached_image'] && news['attached_image'].length > 0"
            >
              <slide
                v-for="(image, idx) in news['attached_image']"
                :key="idx"
              >
                  <img
                  :src="`${APP}/${image['url']}`"
                  :alt="image['name']">
              </slide>
              <hooper-navigation slot="hooper-addons"></hooper-navigation>
            </hooper>
          </div>
        </section>
        <section>
          <div class="section-title"><i class="fas fa-download"></i>檔案下載</div>
          <div class="attach-files" >
            <ul>
              <li 
                v-for="(file, idx) in news['attached_file']"
                :key="idx"
              >
                <a :href="file['url']">{{file['name']}}</a>
              </li>
            </ul>
          </div>
        </section>
      </article>
    </div>
  </div>
</template>

<script>
  import HeaderSlide from '@/components/frontstage/HeaderSlide.vue';
  import api from '@/api/frontstage'

  import {
    Hooper,
    Slide,
    Navigation as HooperNavigation,
    Pagination as HooperPagination
  } from 'hooper';
  import 'hooper/dist/hooper.css';
  export default {
    name: 'news',
    components: {
      HeaderSlide,
      Hooper,
      Slide,
      HooperNavigation,
      HooperPagination
    },
    async created () {
        if (typeof this.$route.params === 'undefined' || typeof this.$route.params.id === 'undefined') {
          return
        }

        let res = await api.get_latest_news(this.$route.params.id)
        if (res.success) {
            console.log('[前臺] news: ', res)
            this.news = res['payload']['payload']
        }
        else {
            this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得文章', res.message)
            return
        }
    },
    data() {
      return {
        APP: process.env.VUE_APP_URL,
        hooperAttachImageSettings: {
          autoPlay: false,
          playSpeed: 5000,
          transition: 1000,
          infiniteScroll: false,
          wheelControl: false,
          itemsToShow: 3,
          itemsToSlide: 3,
        },
        news: {}
      }
    }
  }
</script>

<style lang="scss" scoped>
  .des {
    white-space: pre-line;
  }
  .accesskey-content{
    color: white;
  }
</style>
